import get from 'lodash/get'
import { collections } from '@common/constants'
const state = {
  sites: [],
  currentSite: null,
}

const getters = {
  sites: (state) => state.sites,
  currentSite: (state) => state.currentSite,
  // TODO: worksite only, see mixin/customers.js
  currentSiteName: (state) => get(state, 'currentSite._source.siteName', null),
  // TODO: worksite only: defaultFloor exists on each site kind in mappings,
  // but in practice it is never populated on created renter sites & is undefined.
  currentDefaultFloor: (state) =>
    get(state, 'currentSite._source.defaultFloor', null),
  // TODO: worksite only
  currentAreas: (state) => get(state, 'currentSite._source.area', []),
  styles: (state) => get(state, 'currentSite._source.styles', []),
  floors: (state) => get(state, 'currentSite._source.floors', []),
  // TODO: worksite only, wirepas only
  floorMatching: (state) =>
    get(state, 'currentSite._source.floorMatching.Wirepas', {}),
  // TODO: worksite only
  datasetId: (state) => get(state, 'currentSite._source.datasetId', null),
}

const actions = {
  FETCH_SITES: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      console.warn(
        '[sites.FETCH_SITES] unable to find valid customerIndex & data. aborting.',
      )
      return
    }

    const customerIndex = rootGetters['auth/currentIndex']
    const isCustomerRenter = rootGetters['auth/isCustomerRenter']

    const sites = []
    try {
      await kuzzle.collection.refresh(customerIndex, collections.SITES)

      let body = {}

      // when on renter customers, we only want to fetch active sites, so we exclude archived sites form fetch
      // worksite customers' site do not have the flag so we MUST NOT search by this criteria (will not match any site match)
      if (isCustomerRenter) {
        body.query = {
          term: {
            isArchived: {
              value: false,
            },
          },
        }
      }

      let searchResult = await kuzzle.document.search(
        customerIndex,
        collections.SITES,
        body,
        {
          scroll: '30s',
        },
      )
      while (searchResult) {
        searchResult.hits.forEach((hit) => {
          sites.push(hit)
        })
        searchResult = await searchResult.next()
      }
    } catch (error) {
      console.error(error)
      throw error
    }

    if (!sites.length) {
      console.error(
        `[sites.FETCH_SITES][${customerIndex}] no sites fetched, app will not work ! fix customer or sites.`,
      )
    }

    //TODO MGA: boom current site is a dumb "first site found" rule in array of sites fetched for current customer. TOFIX: use locally saved current site if any ! and update it when changed (renter sites)
    commit('SET_CURRENT_SITE', sites[0])
    commit('SET_SITES', sites)
  },
}

const mutations = {
  SET_CURRENT_SITE: (state, site) => {
    state.currentSite = site
  },
  SET_SITES: (state, sites) => {
    state.sites = sites
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
